import { render, staticRenderFns } from "./ViewPost.vue?vue&type=template&id=c7e41872&scoped=true"
import script from "./ViewPost.vue?vue&type=script&lang=js"
export * from "./ViewPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e41872",
  null
  
)

export default component.exports